export const ROUTES = {
  accountSettingsPage: '/account/settings',
  questionnairePage: '/rg/questionnaire',
  courseAboutPage: '/courses/:courseId/about',
  instructorDashboardPage: '/courses/:courseId/instructor',
  supportPage: '/rg/support',
  coursesPage: '/courses',
};
